import { h } from 'preact';
import IconCaratRightSmall from 'utils/icon/icon-carat-right-small.svg';
import { useEffect, useMemo, useRef } from 'preact/hooks';
import IconCloseSmall from 'utils/icon/icon-close-small.svg';

const NavItem = ({ item, linksData }) => {
  const container = useRef(null);
  const itemData = useMemo(
    () => linksData && linksData.find((i) => item.handle === i.handle),
    [item, linksData],
  );

  useEffect(() => {
    container.current?.classList.add('opacity-100');
  }, []);

  return (
    <li ref={container} className="transition-opacity ease-in duration-900 opacity-0">
      <a
        href={item.url}
        className="flex p-1 items-center rounded bg-grey-F7 [@media(pointer:fine)]:[&_svg]:hover:text-supergoop-yellow h-20 no-underline mb-2.5"
      >
        {!!itemData && (
          <div className="w-[52px] h-[73px] mr-5">
            <img src={itemData.image} alt={itemData.title} />
          </div>
        )}
        <div className={`flex items-center text-base text-grey-2A body text-4 ${itemData?.image ? '' : 'pl-5'}`}>
          {item.title}
        </div>
        <div className="flex items-center pr-5 text-white ml-auto">
          <IconCaratRightSmall />
        </div>
      </a>
    </li>
  );
};

const HeaderSecondaryNav = ({ menu, linksData, isOpen, animation = 'slide' }) => {
  const container = useRef(null);
  const isFadeAnimation = animation === 'fade';
  const fadeClassNames = isFadeAnimation ? 'transition-all delay-150 duration-1100' : 'lg:-translate-x-full'

  return (
    <div
      ref={container}
      className={`${fadeClassNames} w-full lg:w-[440px] lg:!translate-x-0 lg:absolute top-0 bottom-0 ${isOpen ? 'opacity-100 z-50' : 'lg:opacity-0'} bg-white h-full lg:z-[-1]`}
    >
      <ul className="lg:p-10">
        <li className="border-b lg:border-0">
          <ul className="px-5 lg:px-0">
            {menu && menu?.links.map((item) => (
              <NavItem key={item.id} item={item} linksData={linksData} />
            ))}
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default HeaderSecondaryNav;
